import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/button-smasher/intro_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={788}
              height={765}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#DB2F91" }}>Introduction</span>
            </h2>
            <p>
              The idea to revolutionize game reviews came as a consequence of
              declining trust in review platforms. ButtonSmasher is a platform
              designed to reignite this trust and provide an educational
              experience in the world of gaming.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
